import { GET_CARRIER_TYPES, GET_CARRIER_TYPES_SUCCESS, GET_CARRIER_TYPES_ERROR } from "./actionTypes";

export const getCarrierTypes = (user) => {
  return {
    type: GET_CARRIER_TYPES,
    payload: { user },
  };
};

export const getCarrierTypesSuccess = (message, carrier_types) => {
  return {
    type: GET_CARRIER_TYPES_SUCCESS,
    payload: { message, carrier_types },
  };
};

export const getCarrierTypesError = (message) => {
  return {
    type: GET_CARRIER_TYPES_ERROR,
    payload: message,
  };
};
